import React from "react";

import "./ProgressCard.scss";
type ContentType = {
  id?: string;
  title?: string;
  description?: string;
  link?: string;
  is_primary?: boolean;
  position?: number;
  master_content?: string;
  content_type?: string;
  thumbnail?: null | string;
  is_free?: boolean;
  is_complete?: boolean;
  current?: boolean;
};
type PropsType = {
  content: ContentType;
};
export default function ProgressCard(props: PropsType) {
  const { content } = props;

  const getThumbnail = () => {
    switch (content.content_type) {
      case "audio":
        return "bookmark_thumbnail.png";
      case "video":
        return "video_thumbnail.png";
      case "image":
        return "notes_thumbnail.png";
      default:
        return "bookmark_thumbnail.png";
    }
  };

  return (
    <div className={`custom_card StepProgress-item ${content?.is_complete ? "is-done" : content?.current ? "current" : "coming"}`}>
      <div className="progress_info">
        <div className=" custom_card progress_card ">
          <img src={content.thumbnail ?? getThumbnail()} alt="video" className="progress_image" />
          <div className="progress_text">
            <h5>{content?.title}</h5>
            <p>{content?.description}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
